/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Prop_FallbackInputs */

const cs_builder_prop_fallback = /** @type {(inputs: Builder_Prop_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Záloha`)
};

const en_builder_prop_fallback = /** @type {(inputs: Builder_Prop_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallback`)
};

/**
* | output |
* | --- |
* | "Fallback" |
*
* @param {Builder_Prop_FallbackInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_prop_fallback = /** @type {((inputs?: Builder_Prop_FallbackInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Prop_FallbackInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_prop_fallback(inputs)
	return cs_builder_prop_fallback(inputs)
});